<template>
  <div>
    <pulse-loader :style="style" v-if="loading" sm=12 class="text-center align-content-center align-items-center" color="#290A99"/>
    <div v-else :style="style">
    <div v-for="item in data" :key="item.store_id" style="border: none">
      <b-list-group style="border: none">
        <b-list-group-item
          class="flex-column align-items-start pt-1 pb-1 pr-3 pl-3 border-left-0 border-right-0 border-top-0">
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1 text-info">{{item.location}}</h6>
            <small>{{item.retailName}}</small>
          </div>
          <b-container fluid>
            <b-row>
              <b-col cols="auto">
                <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"/>
                Crecimiento: {{item.variation | percentage}}
              </b-col>
              <b-col cols="auto">
                Stock: {{item.stock | numberFormat(appMetric)}}
              </b-col>
            </b-row>
          </b-container>
        </b-list-group-item>
      </b-list-group>
    </div>
    </div>
  </div>

</template>

<script>
  import { sales } from '../../../services/api/ExpertoRetail'
  import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  import { metricOptions, filterOptions } from '@/expertoRetail/atoms/AccumulatedSales/Common/baseParameters'
  export default {
    name: 'TheStoreGrowthDashboardCard',
    mixins: [GeneralUtils, DimensionUtils],
    props: {
      selectedDim: {
        required: false,
        default: ''
      },
      height: {
        default: 200
      },
      storeGrowth: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        style: '',
        loading: false,
        data: null
      }
    },
    created () {
      this.style = 'overflow: auto; height: ' + String(this.height) + 'px'
      this.loadData()
      this.$eventHub.$on('filter-pane-filter-update', this.loadData)
      this.$eventHub.$on('sellout-dashboard-metric-option-changed', this.loadData)
    },
    beforeDestroy () {
      this.$eventHub.$off('sellout-dashboard-metric-option-changed', () => {})
    },
    watch: {
      appMetric () {
        this.loadData()
      },
      vuexFactTable () {
        this.loadData()
      },
      vuexAvailableHeight () {
        this.style = 'overflow: auto; height: ' + String(this.vuexAvailableHeight) + 'px'
      },
      salesAnalysisFilters: {
        deep: true,
        handler (newFilter) {
          this.loadData()
        }
      },
    },
    computed: {
      appMetric () {
        return this.$store.state.metric
      },
      vuexFactTable () {
        return this.$store.state.accumulatedSales.factTable
      },
      vuexAvailableHeight () {
        return Math.round(this.$store.state.appAvailableHeight - 450)
      },
      salesAnalysisFilters () {
        return this.$store.state.salesAnalysis.filters
      },
    },
    methods: {
      setInfoWindowMapData (data) {
        let infoWindow = {
          position: JSON.parse(data.coordinate),
          winOpen: true,
          retailName: data.retailName,
          storeName: data.location,
          storeId: data.id,
          sales1: this.$_formatMetricValue(this.appMetric, data.sales1),
          sales2: this.$_formatMetricValue(this.appMetric, data.sales2),
          var: data.variation,
          stock: this.$_formatMetricValue(this.appMetric, data.stock),
          zoom: 50
        }
        this.$store.commit('commit_googleMapsInfoWindow', infoWindow)
      },
      loadData () {
        this.loading = true
        let reqSales1 = metricOptions[this.appMetric].normal[0]
        let reqSales2 = metricOptions[this.appMetric].normal[1]
        let reqStock = metricOptions[this.appMetric].normal[4]
        let metricVariation = metricOptions[this.appMetric].varResponse[0]
        this.data = this.storeGrowth.data.map(
                ({store_id: id,
                  retail_store_name: location,
                  retail_name: retailName,
                  [metricVariation]: variation,
                  [reqSales1]: sales1,
                  [reqSales2]: sales2,
                  [reqStock]: stock,
                  gmap_coordinate: coordinate}) =>
                  ({id, location, retailName, sales1, sales2, stock, variation, coordinate})).filter(x => (x.coordinate != null))
        this.loading = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/components/Dashboard/StoreGrowth.vue